export default {
    getAssessmentsOfADivision: '/assessment/getAssessmentsOfADivision'
};
